import { render, staticRenderFns } from "./VoteProgress.vue?vue&type=template&id=a80f849c&scoped=true"
import script from "./VoteProgress.vue?vue&type=script&lang=js"
export * from "./VoteProgress.vue?vue&type=script&lang=js"
import style0 from "./VoteProgress.vue?vue&type=style&index=0&id=a80f849c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80f849c",
  null
  
)

export default component.exports